import { render, staticRenderFns } from "./quill.vue?vue&type=template&id=ec63f8de&"
import script from "./quill.js?vue&type=script&lang=js&"
export * from "./quill.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\e-trailor\\Bont\\Frontend\\BontScheduler.Portal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ec63f8de')) {
      api.createRecord('ec63f8de', component.options)
    } else {
      api.reload('ec63f8de', component.options)
    }
    module.hot.accept("./quill.vue?vue&type=template&id=ec63f8de&", function () {
      api.rerender('ec63f8de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientApp/components/common/inputs/quill.vue"
export default component.exports